/**
 * MUI sx style helpers for YourNotesNode.
 * Kept separate to avoid cluttering the component.
 */

export function getSelectMenuSx() {
    return {
        bgcolor: '#0b1e2e',
        border: '0.5px solid #294766',
        borderRadius: '4px',
        mt: '2px',
        '& .MuiMenuItem-root': {
            fontSize: '12px',
            color: '#a3d1ff',
            padding: '6px 12px',
        },
        '& .MuiMenuItem-root:hover': {
            bgcolor: '#0d1f33',
        },
        '& .MuiMenuItem-root.Mui-selected': {
            bgcolor: '#1a3d5c',
            color: '#66b2ff',
        },
        '& .MuiMenuItem-root.Mui-selected:hover': {
            bgcolor: '#1a3d5c',
        },
    };
}
